
class exports.Product

    constructor: ->
        @id = null
        @seed_companies_id = null
        @name = ''
        @trait_packages_id = null

        @active = null
        @is_placeable = null

        @treatment_options = []

        # this should be set by the controller in the setProductFullNames()
        # method
        @full_name = ''
